import { cn } from '@/utils/cn';
interface Props {
  className?: string;
}
const CarouselSkeleton = ({
  className
}: Props) => {
  return <div className={cn('flex h-full w-full gap-2 overflow-hidden lg:gap-4', className)} data-sentry-component="CarouselSkeleton" data-sentry-source-file="skeleton.tsx">
            {Array(8).fill(null).map((_, i) => <div key={i} className='h-[150px] w-[90px] shrink-0 animate-pulse rounded bg-gray-100 lg:h-[292px] lg:w-[175.2px]' />)}
        </div>;
};
export default CarouselSkeleton;